import PropTypes from 'prop-types';
import css from './Wrapper.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export var Wrapper = function Wrapper(_ref) {
  var wrap = _ref.wrap,
      children = _ref.children;
  return wrap ? /*#__PURE__*/_jsx("div", {
    className: css.wrap,
    children: children
  }) : children;
};
Wrapper.propTypes = {
  children: PropTypes.any,
  wrap: PropTypes.bool
};